import createTextMaskInputElement from 'text-mask-core/src/createTextMaskInputElement.js';
export function textMask(textMaskConfig) {
    const { inputElement } = textMaskConfig;
    const textMaskInputElement = createTextMaskInputElement(textMaskConfig);
    const inputHandler = ({ target: { value } }) => textMaskInputElement.update(value);
    inputElement.addEventListener('input', inputHandler);
    textMaskInputElement.update(inputElement.value);
    return {
        textMaskInputElement,
        destroy() {
            inputElement.removeEventListener('input', inputHandler);
        },
    };
}
//# sourceMappingURL=text-mask.js.map